import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import logo from '../assets/images/logo.png';
import bg from '../assets/images/login-bg.png';

import upArrow from '../assets/svg/up.svg';
import downArrow from '../assets/svg/down.svg';

import editIcon from '../assets/svg/edit.svg';
import image from '../assets/svg/image.svg';

import {
    Container,
    Row,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';

class CompetitionPreviewPage extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    componentDidMount() {
        if (!localStorage.token) {
            return;
        }

        if (this.props[0].match.params.id) {
            fetch('https://api.novamedia.agency/admin/fetchOne/competition/' + this.props[0].match.params.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                }
            }).then((res) => res.json()).then((result) => {
                console.log(result);
                this.setState(
                    result
                )
            })

        }

    }

    render() {

        return (
            <div className="page-wrap">
                {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid>

                    <Row className="page-title">
                        <Col lg="12">
                            <h3>Bewerben</h3>
                        </Col>

                    </Row>

                    <Row>
                        <Col lg="12" >
                            <Container fluid className="form-box contact-box">
                                <Row>
                                    <Col lg="3">
                                        <label>NAME</label>
                                        <p>{this.state.name}</p>
                                    </Col>

                                    <Col lg="3">
                                        <label>E-MAIL</label>
                                        <p>{this.state.email}</p>
                                    </Col>
                                    <Col lg="3">
                                        <label>BEREICH</label>
                                        <p>{this.state.position}</p>
                                    </Col>

                                    <Col lg="12" className="spacer">
                                        <div></div>
                                    </Col>
                                    <Col lg="12">
                                        <h3 className="title">NACHRICHT</h3>
                                        <p className="content">
                                            <p>{this.state.message}</p>

                                        </p>
                                    </Col>
                                    {this.state.cv && this.state.cv[0] ?
                                        <Col lg="12">
                                            <a href={this.state.cv[0]}>
                                                <button className="button">Lebenslauf/Bewerbung</button>
                                            </a>
                                        </Col>
                                        :
                                        null
                                    }
                                    {this.state.cv && this.state.cv[0] ?

                                        <Col lg="12">
                                            <a href={this.state.cv[1]}>
                                                <button className="button">Lebenslauf/Bewerbung</button>
                                            </a>
                                        </Col>
                                        :
                                        null
                                    }


                                </Row>
                            </Container>
                        </Col>
                    </Row>

                </Container>


            </div>
        );
    }
}

export default Page(CompetitionPreviewPage);